import { Button } from "../../Button";
import { Container, Photo, Content, Title, Description } from "./styles";

export const Medium = ({ image, title, description, onAction }) => (
  <Container className="AssessmentsCompleted">
    <Photo src={image} alt="" />
    <Content className="AssessmentsCompleted--content">
      <Title class="assessment-count">{title}</Title>
      <Description>{description}</Description>
      <Button onClick={onAction}>Talk to us now</Button>
    </Content>
  </Container>
);
